import { useQuery } from "react-query"
import { useDispatch } from "react-redux";
import { IOption } from "../Interfaces/Common/IOption";
import { IPricingProgram } from "../Interfaces/Common/IPricingProgram";
import { ApplicationDispatch, SET_SERVER_MESSAGE, SET_VEHICLE_INFO } from "../store/application/types";
import { fetchData } from "./fetch";

export const getPricingPrograms = async (dispatch: ApplicationDispatch) => {
  try {
    const url = `api/Lookup/PricingPrograms`;
    const x = await fetchData(url, dispatch);
    return x as IPricingProgram[];
  } catch (err: any) {
    dispatch({
      type: SET_SERVER_MESSAGE,
      payload: { isError: true, message: err as string }
    });
    return undefined;
  }
}
export const usePricingPrograms = () => {
  const dispatch = useDispatch<ApplicationDispatch>();  
  return useQuery(
    ['PricingPrograms'],
    async () => await getPricingPrograms(dispatch),
    {
      refetchOnWindowFocus: false,
    }
  );
}

export const getOptions = async (dispatch: ApplicationDispatch) => {
  try {
    const url = `api/Lookup/Options`;
    const x = await fetchData(url, dispatch);
    return x as IOption[];
  } catch (error: any) {
    dispatch({
      type: SET_SERVER_MESSAGE,
      payload: { isError: true, message: error }
    });
    return undefined;
  }
}

export const getVinNumber = async (dispatch: ApplicationDispatch, vin: string) => {
  //const dispatch = useDispatch<ApplicationDispatch>();  
  try {
    const url = `https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVin/${vin}?format=json`;
    const response = await fetch(`${url}`);
    if (!response.ok) {
        throw new Error(response.statusText);
    }

    const vinInfo: {Results: {Value: string, ValueId: string, Variable: string, VariableId: number}[]} = await response.json();
    const hasError = vinInfo?.Results.find(r => r.VariableId === 143)?.Value !== "0";

    if(!hasError){
      const yearResult = vinInfo.Results.find(r => r.VariableId === 29)?.Value;

      const make = vinInfo.Results.find(r => r.VariableId === 26)?.Value as string;
      const model = vinInfo.Results.find(r => r.VariableId === 28)?.Value as string;
      const year = yearResult ? parseInt(yearResult) : 0;

      dispatch({
        type: SET_VEHICLE_INFO,
        payload: { vehicleUpdateInfo: {make, model, year} }
      }); 
    } else {
      const make = 'Not Found';
      const model = 'Not Found';
      const year = 0;
      dispatch({
        type: SET_VEHICLE_INFO,
        payload: { vehicleUpdateInfo: {make, model, year } }
      });
    }
  } catch (error: any) {
    dispatch({
      type: SET_SERVER_MESSAGE,
      payload: { isError: true, message: error }
    });
    return undefined;
  }
}

export const useOptions = () => {
  const dispatch = useDispatch<ApplicationDispatch>();  
  return useQuery(
    ['Options'],
    async () => await getOptions(dispatch),
    {
      refetchOnWindowFocus: false,
    }
  );
}
